import { render, staticRenderFns } from "./NewRadioButtonGroup.vue?vue&type=template&id=bd48506e&scoped=true"
import script from "./NewRadioButtonGroup.vue?vue&type=script&lang=ts"
export * from "./NewRadioButtonGroup.vue?vue&type=script&lang=ts"
import style0 from "./NewRadioButtonGroup.vue?vue&type=style&index=0&id=bd48506e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd48506e",
  null
  
)

export default component.exports